export default{
        column: [
                {
                  type: 'select',
                  label: '项目名称',
                  dicData: [],
                  cascaderItem: [],
                  span: 6,
                  display: true,
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  prop: 'projectId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择下拉选择器'
                    }
                  ]
                },

                {
                  type: 'select',
                  label: '使用科室',
                  dicData: [],
                  cascaderItem: ['acceptUserId'],
                  span: 6,
                  display: true,
                
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'deptId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择仓库'
                    }
                  ]
                },
                {
                  type: 'input',
                  label: '发放单号',
                  disabled:true,
                  span:6,
                  prop: 'distributeNo',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '单号'
                    }
                  ]
                },
                {
                  type: 'select',
                  label: '单据状态',
                  disabled:true,
                  span:6,
                  valueType:'number',
                  dataType:'number',
                  dicUrl:'/api/blade-system/dict/dictionary?code=warehouse_distribute_status',
                  props:{
                    label:'dictValue',
                    value:'dictKey'
                  },
                  value:1,
                  prop: 'distributeStatus',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '单号'
                    }
                  ]
                },
               
                {
                  type: 'input',
                  label: '发放人',
                  dicData: [],
                  span: 6,
                  disabled:true,
                  display: true,
                  filterable:true,
                  // formslot:true,
                  dataType:'string',
                  props: {
                    label: 'realNameAndPhone',
                    value: 'id'
                  },
                  prop: 'submitUserIdName',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择发放人'
                    }
                  ]
                },
                {
                  type: 'datetime',
                  label: '发放时间',
                  cascaderItem: [],
                  span: 6,
                  disabled:true,
                  display: true,
                  dicOption: 'static',
                  props: {
                    label: 'label',
                    value: 'value'
                  },
                  prop: 'submitTime',
                  required: true,
                  
                  value:new Date(),
                  format: 'yyyy-MM-dd HH:mm:ss',
                  valueFormat: 'yyyy-MM-dd HH:mm:ss'
                },
                {
                  type: 'tree',
                  label: '使用人',
                  dicData: [],
                  span: 6,
                  display: true,
                  // dicUrl:'/api/v4ward/user/user-list-by-dept?deptId={{key}}',
                  dataType:'string',
                  props: {
                    label: 'realNameAndPhone',
                    value: 'id'
                  },
                  prop: 'acceptUserId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择使用人'
                    }
                  ]
                },
              
                {
                  type: 'datetime',
                  label: '确认时间',
                  cascaderItem: [],
                  span: 6,
                  disabled:true,
                  display: true,
                  dicOption: 'static',
                  props: {
                    label: 'label',
                    value: 'value'
                  },
                  prop: 'confirmTime',
                  required: true,
                
                
                  format: 'yyyy-MM-dd HH:mm:ss',
                  valueFormat: 'yyyy-MM-dd HH:mm:ss'
                },
                {
                  type: 'textarea',
                  label: '发放备注',
                  span: 24,
                  maxlength: 300,
                  showWordLimit: true,
                  display: true,
                  prop: 'description'
                },
                {
                  type: 'textarea',
                  label: '',
                  labelWidth:0,
                  span: 24,
                  formslot:true,
                  display: true,
                  prop: 'dataList'
                }
              ],
              labelPosition: 'right',
              labelSuffix: '：',
              labelWidth: 100,
              gutter: 0,
              submitBtn: true,
              submitIcon:'none',
              submitText: '保存',
              emptyBtn:false,
              menuBtn: true,
              menuPosition: 'center',
              disabled:false,
              
}
